import './back-btn.scss';

export default ({ clickHandler }) => {
  return <button onClick={() => clickHandler()} className='Back-btn' />
};



// WEBPACK FOOTER //
// ./src/components/atoms/BackBtn/index.js